<script setup>
import {lg} from "../../../../utils/breakpoints";
import TicPatientStrip from "./TicPatientStrip.vue";
import ContactPointPatientStrip from "./ContactPointPatientStrip.vue";
import {mdiMagnify} from "@mdi/js";

const props = defineProps({
  hpo: {
    type: Object,
    required: true
  },
  member: {
    type: Object,
    required: true
  },
  anyLoading: {
    type: Boolean,
    required: true
  },
  hospitalList: {
    type: Object,
    required: true
  },
  patientList: {
    type: Array,
    required: true
  },
  alertList: {
    type: Array,
    required: true
  },
  now: {
    type: Object,
    required: true
  }
})
const emit = defineEmits(['displayActionsModal'])

function handleDisplayActionsModal(patient) {
  emit('displayActionsModal', patient)
}

function handleSetEditedTransportData(patient) {
  console.log(patient)
}

</script>

<template>
  <v-empty-state v-if="patientList.length === 0"
                 :icon="mdiMagnify"
                 :title="gettext('No patients found')">
  </v-empty-state>


  <template v-if="lg">
    <v-table v-if="patientList.length > 0"
             density="compact"
             :fixed-header="true"
             :hover="true"
             id="tic-patient-list-table"
    >
      <thead>
      <tr>
        <th>{{ pgettext('label', 'Actions') }}</th>
        <th>{{ pgettext('label', 'Patient status') }}</th>
        <th>{{ pgettext('label', 'Destination Hospital') }}</th>
        <th>{{ pgettext('label', 'Temporary Identifier') }}</th>
        <th>{{ pgettext('label', 'TIC Card Number') }}</th>
        <th>{{ pgettext('label', 'Color') }}</th>
        <th>{{ pgettext('label', 'Gender') }}</th>
        <th>{{ pgettext('label', 'Last Name') }}</th>
        <th>{{ pgettext('label', 'First Name') }}</th>
        <th>{{ pgettext('label', 'Birth Date') }}</th>
        <th class="text-left">{{ pgettext('label', 'Diagnose') }}</th>
        <th>{{ pgettext('label', 'ALV') }}</th>
        <th>{{ pgettext('label', 'Unit Type') }}</th>
        <th>{{ pgettext('label', 'Call Sign / LP') }}</th>
        <th>{{ pgettext('label', 'Hospital Type') }}</th>
      </tr>
      </thead>
      <tbody>
      <ContactPointPatientStrip v-for="patient in patientList"
                                :key="patient.id"
                                :patient="patient"
                                :member="member"
                                :alertList="alertList"
                                :now="now"
                                @displayActionsModal="handleDisplayActionsModal"
                                @setEditedTransportData="handleSetEditedTransportData"/>
      </tbody>
    </v-table>
  </template>
  <template v-else>
    <!-- TODO: IMPLEMENT MOBILE CARD -->
    <h1>IMPLEMENT MOBILE CARD</h1>
  </template>
</template>

<style scoped>
th {
  padding: 0 2px !important;
  text-align: center !important;
}
</style>